import * as Net from 'util/Net';

export interface LLMAgentGuidelinesResponse {
  content: string | null;
}

/**
 * Fetch the current user's LLM agent customization guidelines.
 * These guidelines apply to all LLM agents (Deep Research, Compose, Ask, etc.).
 */
export async function getUserLLMAgentGuidelines(): Promise<string | null> {
  const response: LLMAgentGuidelinesResponse = await Net.getJSONPromise(
    '/1/api/users/me/llm-agent-guidelines'
  );
  return response.content;
}

/**
 * Update the current user's LLM agent customization guidelines.
 * These guidelines apply to all LLM agents (Deep Research, Compose, Ask, etc.).
 */
export async function setUserLLMAgentGuidelines(guidelines: string): Promise<void> {
  await Net.putJSONPromise({
    url: '/1/api/users/me/llm-agent-guidelines',
    data: {guidelines},
  });
}
